import $ from 'jquery';
import { directiveSettings } from '../../utils/parse';
import { onResize } from '../../utils/window';

export default function inspectScrollDirective(context=document.body) {
	const $context = $(context);

	$context.find('[sw-inspect-scroll]').each(function() {
		const $element = $(this);
		const json = $element.attr('sw-inspect-scroll');
		const settings = directiveSettings(json, {
			target: null,
			class: 'is-scrollable',
			inverted: false,
		}, 'target');

		const $target = settings.target ? $(settings.target) : $element;

		if ($target.length > 0) {
			onResize(function() {
				const width = $target.width();
				const scrollWidth = $target[0].scrollWidth;

				const height = $target.height();
				const scrollHeight = $target[0].scrollHeight;

				const isScrolling = scrollWidth - width > 0 || scrollHeight - height > 0;

				$element.toggleClass(settings.class, settings.inverted ? !isScrolling : isScrolling);
			});
		}
	});
}



// WEBPACK FOOTER //
// ./source/scripts/directives/inspect/inspect-scroll.js